import { createFrontendModule } from '@backstage/frontend-plugin-api';
import { ByxAppLayout } from './AppLayout';
import { byxPageLayout } from './PageLayout';
import { SidebarContent } from './Sidebar';

export const navModule = createFrontendModule({
  pluginId: 'app',
  extensions: [SidebarContent, ByxAppLayout, byxPageLayout],
});
